import { Routes, Route, Navigate } from "react-router-dom";
import {Layout} from "../../components/layout";
import Home from "../../pages/dashboard/Home";
import SetupConnectionPage from "../../pages/auth/SetupConnectionPage";
import ProtectedRoute from "../ProtectedRoute";

export enum RouteDefine {
  home = 'home',
  setupConnection = 'setup-connection',
}

const AppRoutes: React.FC = () => {
  return (
    <Routes>
       {/* Redirect root "/" to /setup-connection */}
      <Route path="/" element={<Navigate to={`/${RouteDefine.setupConnection}`} replace />} />

      <Route path={`/${RouteDefine.setupConnection}`} element={<SetupConnectionPage />} />
      <Route
        path={`/${RouteDefine.home}`}
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes; 
